import { render, staticRenderFns } from "./DesktopAbout.vue?vue&type=template&id=b45d1f8e"
import script from "./DesktopAbout.vue?vue&type=script&lang=js"
export * from "./DesktopAbout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports